var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.371,
    height: 21.433,
    viewBox: "0 0 18.371 21.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9961",
    "data-name": "Group 9961",
    transform: "translate(-17632 -3753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-svgrepo-com_15_",
    "data-name": "user-svgrepo-com (15)",
    d: "M19.987,13.581l-3.025-1.512a.833.833,0,0,1-.463-.749V10.249c.073-.089.149-.19.228-.3a7.247,7.247,0,0,0,.935-1.836A1.256,1.256,0,0,0,18.4,6.966V5.7a1.263,1.263,0,0,0-.317-.831V3.184a2.839,2.839,0,0,0-.662-2.066A3.986,3.986,0,0,0,14.283,0a3.987,3.987,0,0,0-3.137,1.118,2.839,2.839,0,0,0-.662,2.067V4.869a1.263,1.263,0,0,0-.317.831V6.966a1.259,1.259,0,0,0,.474.984,6.646,6.646,0,0,0,1.109,2.292V11.29a.837.837,0,0,1-.436.735L8.489,13.566A2.855,2.855,0,0,0,7,16.074V17.1c0,1.5,4.764,1.9,7.283,1.9s7.283-.4,7.283-1.9v-.964A2.841,2.841,0,0,0,19.987,13.581Z",
    transform: "translate(17625 3753)",
    fill: "#530072"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_80249",
    "data-name": "Path 80249",
    transform: "translate(17638.889 3762.951)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.740966796875 10.98193645477295 C 2.851086854934692 10.98193645477295 0.4999968111515045 8.630846977233887 0.4999968111515045 5.740966796875 C 0.4999968111515045 2.851086854934692 2.851086854934692 0.4999968111515045 5.740966796875 0.4999968111515045 C 8.630846977233887 0.4999968111515045 10.98193645477295 2.851086854934692 10.98193645477295 5.740966796875 C 10.98193645477295 8.630846977233887 8.630846977233887 10.98193645477295 5.740966796875 10.98193645477295 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.740966796875 0.9999971389770508 C 3.126787185668945 0.9999971389770508 0.9999971389770508 3.126787185668945 0.9999971389770508 5.740966796875 C 0.9999971389770508 8.355146408081055 3.126787185668945 10.48193645477295 5.740966796875 10.48193645477295 C 8.355146408081055 10.48193645477295 10.48193645477295 8.355146408081055 10.48193645477295 5.740966796875 C 10.48193645477295 3.126787185668945 8.355146408081055 0.9999971389770508 5.740966796875 0.9999971389770508 M 5.740966796875 -2.86102294921875e-06 C 8.911617279052734 -2.86102294921875e-06 11.48193645477295 2.570317268371582 11.48193645477295 5.740966796875 C 11.48193645477295 8.911617279052734 8.911617279052734 11.48193645477295 5.740966796875 11.48193645477295 C 2.570317268371582 11.48193645477295 -2.86102294921875e-06 8.911617279052734 -2.86102294921875e-06 5.740966796875 C -2.86102294921875e-06 2.570317268371582 2.570317268371582 -2.86102294921875e-06 5.740966796875 -2.86102294921875e-06 Z",
    stroke: "none",
    fill: "#530072"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-svgrepo-com_3_",
    "data-name": "arrow-svgrepo-com (3)",
    transform: "translate(17644.629 3766.129) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9960",
    "data-name": "Group 9960",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9959",
    "data-name": "Group 9959",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80248",
    "data-name": "Path 80248",
    d: "M3.624.195,3.429,0,.276,3.154v-3H0V3.624H3.466V3.348h-3Z",
    fill: "#530072",
    stroke: "#530072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriend);
export default __webpack_public_path__ + "static/media/friend.afd6588c7f2f8c6628a6b56fb0f6f56b.svg";
export { ForwardRef as ReactComponent };